module.exports = __webpack_public_path__ + "static/rilkes-book-of-hours-9c61d1af472d2f11c280c70df51e4720.jpg";